import {connect} from 'react-redux';
import PrivacyBureauTermsStepView from '../../../components/views/mx/creditoReal/PrivacyBureauTermsStepView';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import { withRouter } from 'react-router';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import * as ModalActions from '../../../actions/ModalActions';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';

const mapStateToProps = (state, {match}) => {
    const acceptTerms = state.creditoReal.loanApplication.acceptTerms;
    const ui = state.creditoReal.ui;
    const personal = state.creditoReal.loanApplication.applicantPersonal;
    const calculator = state.creditoReal.calculator;
    return {
        acceptTerms,
        loanApplicationToken: match.params.token,
        bureauAlreadyValidated: ui.bureauAskForNipView.bureauAlreadyValidated,
        bureauAlreadyFailed: ui.bureauAskForNipView.bureauAlreadyFailed,
        name: `${personal.firstName} ${personal.lastName}`,
        desiredVehicle: `${calculator.brandSelected.value} ${calculator.modelSelected.value}
            ${calculator.versionSelected.value} ${calculator.yearSelected.value}`
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeAcceptTerms: acceptTerms => dispatch(WizardActions.CHANGE_ACCEPT_TERMS_ACTION.action(acceptTerms)),
        onShowAcceptanceTerms: () => {
            const header = {
                title: 'Aceptación de términos'
            };
            const content = {
                type: MODAL_TYPE.SHOW_VALIDATE_NIP_BUREAU_VIEW
            };
            const options = {
                closeOnOverlayClick: false
            };
            pushDataLayer(DATA_LAYER.BUREAU);
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(header, content, null, options));
        },
        onPressBack: () => dispatch(WizardMXActions.GO_TO_APPLICANT_DOMICILE_MX_ACTION.action()),
        getLoanApplication: token => () => {
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token));
        },
        redirectToCreditHistory: () => dispatch(WizardMXActions.GO_TO_CREDIT_HISTORY_MX_ACTION.action())
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken)
    };
};

const PrivacyBureauTermsStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PrivacyBureauTermsStepView));

export default PrivacyBureauTermsStepContainer;